import { white } from '@kmns-internal/furikake'
import ConstructionIcon from '@mui/icons-material/Construction'
import FlatwareIcon from '@mui/icons-material/Flatware'
import HotelIcon from '@mui/icons-material/Hotel'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import ScaleIcon from '@mui/icons-material/Scale'
import { Box, Stack, Typography } from '@mui/material'
import { IndustryCategoryEnum } from '@ulysses-inc/harami_api_client'
import type React from 'react'
import { HeaderBackButtonMui } from 'src/components/header/HeaderBackButtonMui'
import { ExhaustiveError } from 'src/util/error'
import { IndustryNames } from './constants'

interface OwnProps {
  backTitle: string
  title: string
  subTitle?: string
  onBack: () => void
}

export const getIndustryGroupInfo = (): {
  Icon: null | React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  title: string
} => {
  const searchParams = new URLSearchParams(location.search)
  const industryParam = searchParams.get('industry')

  // パラメータがない場合はデフォルト値を返す
  if (!industryParam) {
    return { Icon: null, title: '' }
  }

  const type = +industryParam as IndustryCategoryEnum

  switch (type) {
    case IndustryCategoryEnum.FOOD:
      return {
        Icon: FlatwareIcon as React.FunctionComponent<
          React.SVGProps<SVGSVGElement>
        >,
        title: IndustryNames.FOOD,
      }
    case IndustryCategoryEnum.MANUFACTURE:
      return {
        Icon: ScaleIcon as React.FunctionComponent<
          React.SVGProps<SVGSVGElement>
        >,
        title: IndustryNames.MANUFACTURE,
      }
    case IndustryCategoryEnum.HOTEL:
      return {
        Icon: HotelIcon as React.FunctionComponent<
          React.SVGProps<SVGSVGElement>
        >,
        title: IndustryNames.HOTEL,
      }
    case IndustryCategoryEnum.LOGISTICS:
      return {
        Icon: LocalShippingIcon as React.FunctionComponent<
          React.SVGProps<SVGSVGElement>
        >,
        title: IndustryNames.LOGISTICS,
      }
    case IndustryCategoryEnum.MACHINE:
      return {
        Icon: ConstructionIcon as React.FunctionComponent<
          React.SVGProps<SVGSVGElement>
        >,
        title: IndustryNames.MACHINE,
      }
    case IndustryCategoryEnum.OTHER:
      return {
        Icon: MoreHorizIcon as React.FunctionComponent<
          React.SVGProps<SVGSVGElement>
        >,
        title: IndustryNames.OTHER,
      }
    case IndustryCategoryEnum.NDF:
      return { Icon: null, title: IndustryNames.NDF }
    case IndustryCategoryEnum.HOSHINO:
      return { Icon: null, title: IndustryNames.HOSHINO }
    case IndustryCategoryEnum.ITOHAM_YONEKYU:
      return { Icon: null, title: IndustryNames.ITOHAM_YONEKYU }
    default:
      throw new ExhaustiveError(type)
  }
}

const TemplateHeader: React.FC<OwnProps> = (props: OwnProps) => {
  const { Icon, title } = getIndustryGroupInfo()
  return (
    <Box pt={3} px={2} pb={8} sx={{ backgroundColor: white }}>
      <HeaderBackButtonMui onClick={() => props.onBack()}>
        {props.backTitle}
      </HeaderBackButtonMui>
      <Stack direction="column" alignItems="center" spacing={1} mt={3}>
        {props.subTitle ? (
          <>
            <Typography variant="h5" align="center">
              {props.title}
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="text.secondary"
            >
              {props.subTitle}
            </Typography>
          </>
        ) : (
          <>
            <Stack direction="row" justifyContent="center" spacing={1}>
              {Icon && (
                <Box
                  sx={{
                    color: 'text.secondary',
                    fontSize: 24,
                  }}
                >
                  <Icon />
                </Box>
              )}
              <Typography variant="subtitle1" color="text.secondary">
                {title}
              </Typography>
            </Stack>
            <Typography variant="h5" align="center">
              {props.title}
            </Typography>
          </>
        )}
      </Stack>
    </Box>
  )
}

export default TemplateHeader
